import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';
import useOrganization from 'hooks/useOrganization';

const Users = () => {
  const entities = useEntities();
  const { organization } = useOrganization();
  const filterGroups = null;

  return (
    <HmsEntityTableController
      entity={entities.User}
      filterGroups={filterGroups}
      columnSets={[
        {
          name: 'Admins',
          filters: { roles: ['SYSTEM_ADMIN', 'ADMIN'] },
          columns: [
          'Name',
          'email',
          'phone',
          'Roles',
          'Organizations',
          ],
        },
        {
          name: 'Team Managers',
          filters: { roles: ['TEAM_MANAGER'] }, 
          columns: [
          'Name',
          'email',
          'phone',
          'Roles',
          'Organizations',
          'ManagedTeams',
          ],
        },
        {
          name: 'Players',
          filters: { roles: ['PLAYER'] },
          columns: [
          'Name',
          'Player',
          'email',
          'phone',
          'Roles',
          'Organizations',
          ],
        },
      ]}
    />
  )
}

export default Users